// import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';

const CodeDisplay = ({ code }) => {
    const [projectName, setProjectName] = useState('');

    // Retrieve project name from local storage when the component mounts
    useEffect(() => {
        const storedProjectName = localStorage.getItem('selectedProjectName');
        if (storedProjectName) {
            setProjectName(storedProjectName);
        }
    }, []);
    
    return (
        <div>
            <h3 className="fw-bold mb-2 mt-5 text-uppercase fw-normal">Project: {projectName || 'No project selected'}</h3>

            <h2 className="fw-bold mb-2 mt-5 text-uppercase fw-normal">Pin</h2>
            <h1 className="fw-bold mb-2 mt-5  fw-normal mb-3 ps-3 pb-3">{code ? `${code}` : 'Fetching code...'}</h1>
    </div>);
    // return <div>{code ? `Code: ${code}` : 'Fetching code...'}</div>;
};

export default CodeDisplay;
